/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Profile = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.4379 19.2509C15.1462 20.0432 13.6264 20.5 12 20.5C10.3736 20.5 8.85382 20.0432 7.56208 19.2509C7.91877 17.1222 9.76994 15.5 12 15.5C14.2301 15.5 16.0812 17.1222 16.4379 19.2509ZM17.7452 18.2645C17.0008 15.797 14.7103 14 12 14C9.28975 14 6.9992 15.797 6.25483 18.2645C4.5615 16.7107 3.5 14.4793 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 14.4793 19.4385 16.7107 17.7452 18.2645ZM18 20.0007C20.4289 18.1763 22 15.2716 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.2716 3.57111 18.1763 6 20.0007C6.45407 20.3418 6.93812 20.6451 7.44748 20.906C7.46496 20.915 7.48247 20.9239 7.5 20.9327C8.85259 21.6154 10.3814 22 12 22C13.6186 22 15.1474 21.6154 16.5 20.9327C17.0223 20.6691 17.5184 20.361 17.9832 20.0134C17.9888 20.0092 17.9944 20.0049 18 20.0007ZM14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9ZM16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9Z"
                        fill={color}
                    />
                </svg>
        );
    };
